import LoginView from "./LoginView";

export const LoginContainer = () => {
  return (
    <div>
      <LoginView />
    </div>
  );
};
